import {
  SAGA_LOGIN_SUCCESS,
  SAGA_LOGIN_INVALID,
  SAGA_LOGIN_ERROR,
  SIGNOUT
} from "../constants";
import jwtDecode from "jwt-decode";
import _ from "lodash";

const extractRole = token => {
  const decoded = jwtDecode(token);
  if (!_.isEmpty(decoded)) {
    return decoded["role"];
  }
  return "";
};

const flushStorage = () => localStorage.clear();
const setToken = token => localStorage.setItem("token", token);
const getToken = () => localStorage.getItem("token");
const verifyLoggedIn = () => (getToken() !== null ? true : false);
const clearToken = () => localStorage.removeItem("token");
const getRole = () => {
  if (verifyLoggedIn()) {
    return extractRole(getToken());
  }
  return "";
};

const initialState = {
  header: { appName: "Admin" },
  app: { selectedAccount: "Kofi" },
  authenticated: verifyLoggedIn(),
  loggingIn: false,
  loginErrors: "",
  role: getRole()
};

const app = (state = initialState, action) => {
  switch (action.type) {
    case SAGA_LOGIN_SUCCESS:
      flushStorage();
      setToken(action.data.jwt);
      return {
        ...state,
        authenticated: true,
        loginErrors: null,
        role: extractRole(action.data.jwt)
      };

    case SAGA_LOGIN_INVALID:
      return {
        ...state,
        loginErrors: "Invalid Login. Please try again"
      };

    case SAGA_LOGIN_ERROR:
      return {
        ...state,
        loginErrors: "Sorry we couldn't authenticate you. Please try again."
      };

    case SIGNOUT:
      clearToken();
      return {
        ...state,
        authenticated: false
      };

    default:
      return state;
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/reducers/app.js